import { post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'

export const changeProcessState = (name, value) => (dispatch, getState) => {
    dispatch({
        type: type.CHANGE_PROCESS_STATE,
        payload: {
            name,
            value,
        },
    })
    dispatch(findTransition())
}

export const changeMode = (name, value) => ({
    type: type.CHANGE_MODE,
    payload: {
        mode: value,
    },
})

export const changeYearWeek = (index, name, value) => (dispatch, getState) => {
    dispatch({
        type: type.CHANGE_YEAR_WEEK,
        payload: {
            index,
            name,
            value: parseInt(value, 10),
        },
    })
    dispatch(findTransition())
}

export const deleteYearWeek = (index) => (dispatch, getState) => {
    dispatch({
        type: type.DELETE_YEAR_WEEK,
        payload: {
            index,
        },
    })
    dispatch(findTransition())
}

export const findTransitionRequest = () => ({
    type: type.FIND_TRANSITION_REQUEST,
})

export const findTransitionSuccess = (transitionList) => ({
    type: type.FIND_TRANSITION_SUCCESS,
    payload: {
        transitionList,
    },
})

export const findTransitionError = (error) => ({
    type: type.FIND_TRANSITION_ERROR,
    payload: {
        error,
    },
})


export const findTransition = () => (dispatch, getState) => {
    const state = getState()
    const processState = selector.selectProcessState(state)
    let yearWeekList = selector.selectYearWeekList(state)

    yearWeekList = yearWeekList.filter(yearWeek => {
        return yearWeek.year && yearWeek.week
    })

    if (yearWeekList.length === 0 || !processState.startProcessName || !processState.startStatus || !processState.endProcessName || !processState.endStatus) {
        return
    }

    dispatch(findTransitionRequest())
    post('/api/process/analytics/get-transition-over-time', {
        ...processState,
        yearWeekList,
    })
        .then(transitionList => {
            dispatch(findTransitionSuccess(transitionList))
        })
        .catch(error => {
            dispatch(findTransitionError(error))
        })
}




// WEBPACK FOOTER //
// ./src/modules/analytics/state/transition/action.js